import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import {modelActionsCreator} from "~/actions/model_actions";
import {getResultPerPage, getResultsPage, getResultsValue, getSearchModel} from "~/stateGetter";
import PaginationBar from '~/components/DataTable/PaginationBar';
import {resultParamsActionCreator} from "~/actions/result_param_actions";

const RXModelResultPagination = connect(
    (state, {modelName}) => {
        let searchModel = getSearchModel(state, modelName);

        return {
            perPage: searchModel.resultParams.perPage,
            currentPage: searchModel.results.value.page,
            total: searchModel.results.value.total,
            readOnlyPerPage: true
        };
    },
    (dispatch, {modelName}) => {
        let actions = resultParamsActionCreator({searchModelName: modelName});

        return {
            onChangePerPage: (perPage) => dispatch(actions.changePerPage(perPage)),
            onChangePage: (page) => dispatch(actions.changePage(page)),
        }
    }
)(PaginationBar);

export default RXModelResultPagination;